import Vue from 'vue'
import Vuex from 'vuex'
import { camelCase } from 'lodash'

let modules = {}

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  '.',
  false,
  /[a-z]\w+\.(js)$/
)

requireComponent.keys().forEach(fileName => {
  const moduleConfig = requireComponent(fileName)

  // TODO: REMOVE CAMELCASE IT CONFUSES STORE NAMES
  const moduleName = camelCase(
    fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  )

  modules = { ...modules, [moduleName]: moduleConfig.default || moduleConfig }
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules
})


// WEBPACK FOOTER //
// ./src/stores/index.js